// extracted by mini-css-extract-plugin
export default {"item":"Item_item__GcsuH","anchor":"Item_anchor__9sYaX","title":"Item_title__AqbpH"};